import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { Constants } from '@shared/class/constants.class';
import { BcAdalAngularService } from 'bc-adal-angular';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
  public constants = new Constants();
  public title: string;
  public accessDenied = false;

  @ViewChild('username') inputUserName: ElementRef;

  constructor(
    public appConfig: AppConfig,
    public adalService: BcAdalAngularService,
    public authenticationService: AuthenticationService
  ) {
    this.title = appConfig.LANG.app;

    this.authenticationService.accessDenied$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(result => {
        this.accessDenied = result;
      });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    this.adalService.login();
  }
}
